<template>
  <div class="renew3_payment">
    <div class="payment_common">
      <!-- コンビニ決済グループ -->
      <div class="payment_group">
        <h3 class="payment_group_title">コンビニで<span class="red">現金</span>による決済</h3>
        <p class="note">※コンテンツ番号が発行されたら、コンビニの複合機で支払います</p>
        <ul class="payment_list">
          <li class="payment_item">
            <div class="p_title">
              <input type="radio" id="how_payment4" name="how_payment" value="convinience"
                v-model="selectedPaymentMethod" />
              <label :class="{ 'selected-label': selectedPaymentMethod === 'convinience' }"
                for="how_payment4">コンビニで支払う</label>
            </div>
            <div class="p_contents" v-if="selectedPaymentMethod === 'convinience'">
              <div class="memo">
                <p class="red_color">※全国のコンビニ（セブンイレブン・ファミリーマート・ローソン・ミニストップ・ポプラ）のマルチコピー機で現金を投入するお支払い方法になります。</p>
                <p class="red_color">※セブンイレブンでは料金が異なる場合があります。</p>
              </div>
              <div class="payment-btn">
                <template v-if="!$firebase.isAuthenticated">
                  <button class="payment-card-btn" @click="$eventHub.$emit('open-login-dialog')">
                    ログインして続行
                  </button>
                </template>
                <template v-else>
                  <button class="payment-card-btn" :id="'convinience-print-payment-' + currentPathEnd"
                    :disabled="isConvinienceButtonDisabled" @click="handleConviniencePayment">コンビニでお支払い</button>
                </template>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <!-- 事前決済グループ -->
      <div class="payment_group"
        v-if="print_type == 1 || print_type == 4 || print_type == 6 || print_type == 7 || print_type == 8 || print_type == 15">
        <!-- v-if="print_type == 1 || print_type == 6"> -->
        <h3 class="payment_group_title"><span class="red">キャッシュレス</span>決済</h3>
        <p class="note"><span class="bold">※ファミリーマート・ローソン・ミニストップ・ポプラ</span>のみ利用可能です</p>
        <ul class="payment_list">
          <li class="payment_item">
            <div class="p_title">
              <input type="radio" id="how_payment1" name="how_payment" value="card" v-model="selectedPaymentMethod" />
              <label :class="{ 'selected-label': selectedPaymentMethod === 'card' }" for="how_payment1">クレジットカード</label>
            </div>
            <div class="p_contents" v-if="selectedPaymentMethod === 'card'">
              <div class="card_form">
                <CardPayment ref="cardPayment" @payment-success="handlePaymentSuccess"
                  @payment-error="handlePaymentError" :onValidationChange="handleValidationChange"
                  :isSubscription="is_subscription" :amount="price" :selectedIndex="selectedIndex"
                  :payment_method_used="payment_method_used" :print_type="print_type" :format_id="format_id" />
              </div>
              <div class="memo">
                <p class="red_color">※事前にオンライン決済を行い、コンビニでQRコードを読み取って印刷します。</p>
                <p class="red_color font_bold">※セブンイレブンではご利用いただけません。</p>
                <p class="red_color">※発行されたコードの有効期限は、3日間となっております。</p>
                <p class="red_color">※お客様のカード情報は保存されません。</p>
                <p class="red_color">※Visa・MasterCard・American Express・JCB・Diners
                  Club・Discoverのクレジットカードがご利用可能です。</p>
              </div>
              <div class="payment-btn">
                <template v-if="!$firebase.isAuthenticated">
                  <button class="payment-card-btn" @click="$eventHub.$emit('open-login-dialog')">
                    ログインして続行
                  </button>
                </template>
                <template v-else>
                  <button class="payment-card-btn" :id="'convinience-print-payment-' + currentPathEnd"
                    :disabled="!isCardFormValid || isCardButtonDisabled"
                    @click="handleCardPayment">クレジットカードでお支払い</button>
                </template>
              </div>
            </div>
          </li>

          <li class="payment_item" v-if="$site.appFlag != 'b'">
            <div class="p_title">
              <input type="radio" id="how_payment2" name="how_payment" value="paypay" v-model="selectedPaymentMethod" />
              <label :class="{ 'selected-label': selectedPaymentMethod === 'paypay' }" for="how_payment2">PayPay</label>
            </div>
            <div class="p_contents" v-if="selectedPaymentMethod === 'paypay'">
              <div class="memo">
                <p class="red_color">※事前にオンライン決済を行い、コンビニでQRコードを読み取って印刷します。</p>
                <p class="red_color font_bold">※セブンイレブンではご利用いただけません。</p>
                <p class="red_color">※発行されたコードの有効期限は、3日間となっております。</p>
                <p class="red_color">※PayPayアプリでの連携後、自動で決済が行われます。決済成功後、マイページにて登録状態を確認できます。</p>
                <p class="red_color">※yagishに戻っても画面が変わらない場合はリロードしてみてください。</p>
              </div>
              <div class="payment-btn">
                <template v-if="!$firebase.isAuthenticated">
                  <button class="payment-paypay-btn" @click="$eventHub.$emit('open-login-dialog')">
                    ログインして続行
                  </button>
                </template>
                <template v-else>
                  <button :id="'convinience-print-payment-' + currentPathEnd" class="payment-paypay-btn"
                    :disabled="isPaypayButtonDisabled" @click="paypayPayment">
                    <img src="/static/renew2_img/paypay_payment_lg.png" class="paypay-btn-img">
                  </button>
                </template>
              </div>
            </div>
          </li>
        </ul>
        <li class="payment_item" v-if="isApplePayAvailable">
          <div class="p_title">
            <input type="radio" id="how_payment3" name="how_payment" value="applepay" v-model="selectedPaymentMethod" />
            <label :class="{ 'selected-label': selectedPaymentMethod === 'applepay' }" for="how_payment3">Apple
              Pay</label>
          </div>
          <div class="p_contents" v-if="selectedPaymentMethod === 'applepay'">
            <div class="memo">
              <p class="red_color">※事前にオンライン決済を行い、コンビニでQRコードを読み取って印刷します。</p>
              <p class="red_color">※セブンイレブンではご利用いただけません。</p>
              <p class="red_color">※発行されたコードの有効期限は、3日間となっております。</p>
              <p class="red_color">※お客様のカード情報は保存されません。</p>
            </div>
            <div class="payment-btn">
              <template v-if="!$firebase.isAuthenticated">
                <button class="payment-applepay-btn" @click="$eventHub.$emit('open-login-dialog')">
                  ログインして続行
                </button>
              </template>
              <template v-else>
                <div v-if="isDisplayApplePayButton" id="convinience-print-payment-request-button"></div>
                <div v-else class="skeleton-loader">
                  <div class="skeleton skeleton-button"></div>
                </div>
              </template>
            </div>
          </div>
        </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import CardPayment from './CardPayment.vue'
import { loadStripe } from '@stripe/stripe-js'
import VueCookies from 'vue-cookies'

export default {
  components: {
    CardPayment
  },
  props: {
    is_simultaneous: {
      type: Boolean,
      default: false
    },
    serviceName: {
      type: String,
      default: 'メール便'
    },
    price: {
      type: Number,
      default: 330
    },
    is_subscription: {
      type: Boolean,
      default: false
    },
    selectedIndex: {
      type: Number,
      default: 1
    },
    payment_method_used: {
      type: String,
      default: ''
    },
    print_type: {
      type: String,
      default: ''
    },
    format_id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      selectedPaymentMethod: '', // デフォルトの支払方法
      publishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
      isCardFormValid: false,
      isApplePayAvailable: false,
      paymentRequest: null,
      isDisplayApplePayButton: false,
      isCardButtonDisabled: false,
      isConvinienceButtonDisabled: false,
      isPaypayButtonDisabled: false
    }
  },
  computed: {
    currentPathEnd () {
      // URLパスを取得
      const path = window.location.pathname
      // パスを'/'で分割して配列にする
      const pathParts = path.split('/')
      // 空の要素を除去
      const filteredParts = pathParts.filter(part => part)
      // 最後の要素を返す
      return filteredParts.length > 0 ? filteredParts[filteredParts.length - 1] : ''
    }
  },
  methods: {
    handleConviniencePayment () {
      this.isConvinienceButtonDisabled = true

      // ファネル分析: 決済開始イベント送信
      this.$gtm.sendEprintEvent('payment_start', {
        payment_method: 'convinience',
        price: this.price,
        print_type: this.print_type,
        format_id: this.format_id
      })

      // セブンイレブンが選択されている場合とその他のコンビニが選択されている場合で同じ処理を実行
      // 実際の印刷時にQRコードで区別される
      this.$emit('request-seven-eleven-payment')
    },
    handlePaymentSuccess (paymentData) {
      console.log('支払い情報:', paymentData)
      this.$message({
        message: '支払いが成功しました。',
        type: 'success'
      })
      this.isCardButtonDisabled = false
      this.$emit('payment-success', paymentData)
    },
    handlePaymentError (error) {
      console.error('支払いエラー:', error)

      // エラーメッセージを取得（具体的なエラーメッセージがある場合はそれを使用）
      let errorMessage = '支払いに失敗しました。'
      if (error && error.message) {
        errorMessage = error.message
      }

      this.$message({
        message: errorMessage,
        type: 'error'
      })
      this.isCardButtonDisabled = false
      this.$emit('payment-error', error)
    },
    handleValidationChange (isValid) {
      this.isCardFormValid = isValid
    },
    handleCardPayment () {
      this.isCardButtonDisabled = true
      if (this.selectedPaymentMethod === 'card' && this.isCardFormValid) {
        // ファネル分析: 決済開始イベント送信
        this.$gtm.sendEprintEvent('payment_start', {
          payment_method: 'card',
          price: this.price,
          print_type: this.print_type,
          format_id: this.format_id
        })

        // クレジットカード決済開始を親コンポーネントに通知
        this.$emit('credit-card-payment-start')
        // `CardPayment` コンポーネントの `processPayment` メソッドを呼び出す
        this.$refs.cardPayment.createToken()
      } else {
        alert('カード情報が無効です')
        this.isCardButtonDisabled = false
      }
    },
    paypayPayment () {
      this.isPaypayButtonDisabled = true

      // ファネル分析: 決済開始イベント送信
      this.$gtm.sendEprintEvent('payment_start', {
        payment_method: 'paypay',
        price: this.price,
        print_type: this.print_type,
        format_id: this.format_id
      })

      if (this.is_subscription) {
        this.yagiprimePaypay()
      } else {
        // 親コンポーネントの処理を呼び出す
        this.$emit('paypay-payment')
      }
    },
    yagiprimePaypay: function (param) {
      const app = this
      // app.fullscreenLoading = true
      app.$eventHub.$emit('loading_on')

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('subscription_type', this.selectedIndex)

      const routeId = VueCookies.get('_YAGISH_YAGIPRIME_ROUTE_ID')
      if (routeId) {
        formData.append('route', routeId)
      } else {
        formData.append('route', '')
      }
      formData.append('app_flag', this.$site.appFlag)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '3')
      formData.append('site_flag', 'r')
      formData.append('redirect_url', window.location.href)
      this.$axios
        .post(this.$varuna.endPoints.paypaySubscriptions, formData, { timeout: 60000 })
        .then(function (response) {
          console.error(response.data.authorization_url)
          location.href = response.data.authorization_url
        })
        .catch(function () {
          app.$message({
            message: '決済失敗しました',
            type: 'error'
          })
          app.$eventHub.$emit('payment_yagiprime_result', 'error')
        }).finally(function () {
          // app.fullscreenLoading = false
          app.$eventHub.$emit('loading_off')
          app.isPaypayButtonDisabled = false
        })
    },
    async initializeExpressCheckout () {
      const stripe = await loadStripe(this.publishableKey)
      const AMOUNT = this.price
      const CURRENCY = 'jpy'
      const LABEL = this.serviceName

      // Apple Pay の paymentRequest を作成または取得
      if (!this.paymentRequest) {
        this.paymentRequest = stripe.paymentRequest({
          country: 'JP',
          currency: CURRENCY,
          total: {
            label: LABEL,
            amount: AMOUNT
          },
          requestPayerName: true,
          requestPayerEmail: true
        })

        // Apple Pay が利用可能か確認
        const result = await this.paymentRequest.canMakePayment()
        this.isApplePayAvailable = !!(result && result.applePay)
      }
    },
    async applePayMount () {
      const stripe = await loadStripe(this.publishableKey)
      const AMOUNT = this.price
      const LABEL = this.serviceName
      const CURRENCY = 'jpy'
      // モードを指定 this.subscriptionがtrueの場合はsubscription、falseの場合はpayment
      const mode = this.is_subscription ? 'subscription' : 'payment'
      const elements = stripe.elements({
        mode,
        amount: AMOUNT,
        currency: CURRENCY
      })

      const customerForm = new FormData()
      customerForm.append('uuid', this.$firebase.user.uid)
      customerForm.append('subscription_type', 1)
      const routeId = VueCookies.get('_YAGISH_YAGIPRIME_ROUTE_ID')
      if (routeId) {
        customerForm.append('route', routeId)
      } else {
        customerForm.append('route', '')
      }

      if (this.is_subscription) {
        console.log('Customerの作成開始')
        const response = await this.$axios.post(this.$varuna.endPoints.createStripeCustomer, customerForm)
        console.log('Customerの作成成功:', response.data.success)
        console.log('IncompleteSubscriptionの作成成功:', response.data.client_secret)
        this.clientSecret = response.data.client_secret
      } else { }

      this.isDisplayApplePayButton = true
      const applePayButton = this.is_subscription ? 'subscribe' : 'buy'
      this.expressCheckoutElement = elements.create('expressCheckout', {
        paymentRequest: this.paymentRequest,
        buttonType: {
          applePay: applePayButton
        }
      })

      this.$nextTick(() => {
        this.expressCheckoutElement.mount('#payment-request-button')
      })

      this.expressCheckoutElement.on('click', async (e) => {
        const options = this.is_subscription
          ? {
              clientSecret: this.clientSecret,
              applePay: {
                recurringPaymentRequest: {
                  paymentDescription: LABEL,
                  regularBilling: {
                    amount: AMOUNT,
                    label: LABEL,
                    recurringPaymentIntervalUnit: 'day',
                    recurringPaymentIntervalCount: 30
                  },
                  billingAgreement:
                '30日間ごとに550円(税込)となります。\n本サービスにお申込みいただき、お客様の登録が完了した時点でご利用代金が引き落とされると同時に、サービスが開始されます。\n初回のサービス提供期間終了後、自動更新され、以降30日ごとに550円（税込）がかかります。\n利用代金は更新されたサービス期間の毎初日に登録された決済情報から引き落とされます。\nお申込み手続きの完了後に、代金の返金やキャンセルはできません。※解約はマイページの「アカウント情報」からお申込みいただけます。',
                  managementURL: 'https://rirekisho.yagish.jp/mypage/account'
                }
              }
            }
          : {}
        if (!this.is_subscription) {
        }

        e.resolve(options)
      })

      this.expressCheckoutElement.on('confirm', async (event) => {
        try {
          if (this.is_subscription) {
            console.log('フォームのデータを送信開始')
            const { error: submitError } = await elements.submit()
            if (submitError) {
              console.error('フォーム送信エラー:', submitError)
              this.$message({
                message: submitError.message,
                type: 'error'
              })
              event.complete('fail')
              return
            }
            console.log('PaymentIntentの確認開始')
            const { error: confirmError } = await stripe.confirmPayment({
              elements,
              clientSecret: this.clientSecret,
              confirmParams: {
                return_url: window.location.href
              }
            })
            console.log(confirmError)
          } else {
            const confirmationToken = event.confirmationToken
            console.log('confirmationToken:', confirmationToken)
          }
        } catch (error) {
          console.error('支払いエラー:', error)
          this.$message({
            message: '支払いに失敗しました。',
            type: 'error'
          })
          event.complete('fail')
        }
      })
    }
  },
  async mounted () {
    if (this.is_subscription) {
      await this.initializeExpressCheckout()
    }
  },
  watch: {
    print_type: {
      handler () {
        this.selectedPaymentMethod = 'convinience'
      },
      immediate: true
    },
    selectedPaymentMethod (newVal, oldVal) {
      console.log('selectedPaymentMethod:', newVal)
      console.log(this.isDisplayApplePayButton)

      // ファネル分析: 決済方法選択イベント送信
      if (newVal && newVal !== oldVal) {
        this.$gtm.sendEprintEvent('payment_method_select', {
          payment_method: newVal,
          price: this.price,
          print_type: this.print_type,
          format_id: this.format_id
        })
      }

      if (newVal === 'applepay') {
        this.applePayMount()
      } else {
        this.isDisplayApplePayButton = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.renew3_payment {
  display: block;

  /*ヤギプライムに加入チェック*/
  .yagiprime_check {
    border: 2px solid #8fbd67;
    border-radius: 10px;
    background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(255, 225, 0, .25)), to(rgba(255, 225, 0, 0)));
    background-image: linear-gradient(180deg, rgba(255, 225, 0, .25), rgba(255, 225, 0, 0));
    padding: 15px;
    margin-bottom: 20px;
  }

  .red_color {
    color: #E3165C;
  }

  .font_bold {
    font-weight: bold;
  }

  .how2 {
    margin-right: 20px;
  }

  .payment_common {
    .payment_list {
      .payment_item {
        .payment-btn {
          min-height: 50px;
          height: 50px;
          text-align: center;
          width: auto;

          .payment-card-btn {
            background: #E3165C;
            color: #fff;
            display: inline-block;
            width: 100%;
            height: 100%;
            border-radius: 10px;
            font-weight: bold;

            &:disabled {
              background: #dfdfdf;
            }

            &:disabled:hover {
              cursor: not-allowed;
              background: #dfdfdf;
              opacity: 1;
            }
          }

          .payment-paypay-btn {
            background: #FF0033;
            color: #fff;
            display: inline-block;
            width: 100%;
            height: 100%;
            border-radius: 10px;
            font-weight: bold;

            &:disabled {
              background: #dfdfdf;
            }

            &:disabled:hover {
              cursor: not-allowed;
              background: #dfdfdf;
              opacity: 1;
            }

            .paypay-btn-img {
              max-height: 49px;
              max-width: 98%;
            }
          }
        }
      }
    }
  }
}

.renew3_payment .yagiprime_check .check_block {
  margin-bottom: 20px;
}

.renew3_payment .yagiprime_check label,
.renew3_payment .yagiprime_check input[type='checkbox'] {
  cursor: pointer;
  font-weight: bold;
  font-size: 16px;
}

.renew3_payment .yagiprime_check input[type="checkbox"] {
  position: relative;
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 1px solid #dfdfdf;
  background: #fff;
  border-radius: 4px;
  vertical-align: -2px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin-right: 3px;
}

.renew3_payment .yagiprime_check input[type="checkbox"]:checked:before {
  position: absolute;
  top: -2px;
  left: 4px;
  transform: rotate(50deg);
  width: 8px;
  height: 12px;
  border-right: 3px solid #E3165C;
  border-bottom: 3px solid #E3165C;
  content: '';
}

.renew3_payment .yagiprime_check .check_icon {
  position: relative;
  top: 3px;
  width: auto;
  height: 16px;
  -o-object-fit: cover;
  object-fit: cover;
}

.renew3_payment .yagiprime_check .t_amount {
  margin-left: 20px;
}

.renew3_payment .yagiprime_check .t_terms {
  font-size: 12px;
}

/*共通*/
.renew3_payment .payment_common {
  margin-bottom: 50px;
}

/*グループ*/
.renew3_payment .payment_group {
  margin-bottom: 30px;
}

.renew3_payment .payment_group_title {
  font-size: 16px;
  font-weight: bold;
  line-height: 20px;
  margin: 0;
  padding: 0 0 0 6px;
  border-left: 6px solid #E3165C;
  border-bottom: none;
}

.renew3_payment .red {
  color: #E3165C;
}

.renew3_payment .note {
  font-size: 10px;
  margin-bottom: 10px;
}

.renew3_payment .bold {
  font-weight: bold;
}

.renew3_payment .payment_common .red_color {
  font-size: 12px;
}

.renew3_payment .payment_common .payment_item {
  border-bottom: 1px solid #dfdfdf;
  padding: 10px 15px;
}

.renew3_payment .payment_common .payment_item:first-child {
  border-top: 1px solid #dfdfdf;
}

.renew3_payment .payment_common .p_contents {
  padding-top: 10px;
}

.renew3_payment .payment_common .p_contentsnone {
  padding-bottom: 0;
}

.renew3_payment .payment_common input[type="radio"] {
  appearance: none;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 1px solid #dfdfdf;
  vertical-align: -3px;
  outline: none;
  background-color: #fff;
}

.renew3_payment .payment_common input[type="radio"]::before {
  display: block;
  content: "";
  width: 9px;
  height: 9px;
  border-radius: 9px;
  background-color: #E3165C;
  transform: translate(2px, 2px) scale(0);
  transform-origin: center;
  transition: all 0.3s cubic-bezier(0.25, 0.25, 0.56, 2);
}

.renew3_payment .payment_common input[type="radio"]:checked::before {
  transform: translate(2px, 2px) scale(1);
}

.renew3_payment .payment_common label {
  margin-left: 10px;
  vertical-align: middle;
}

.renew3_payment .payment_common .payment_list {
  margin-left: 0px;
}

.selected-label {
  font-weight: bold;
}

/*金額*/
.renew3_payment .payment_amount {
  background: #fff;
  border: 1px solid #dfdfdf;
  border-radius: 10px;
  font-weight: bold;
  width: 310px;
  padding: 15px;
  position: sticky;
  top: 0;
  z-index: 1000;
}

.renew3_payment .payment_amount .a-title {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 10px;
}

.renew3_payment .payment_amount .payment-paypay-btn:disabled {
  background: #dfdfdf;
}

.renew3_payment .payment_amount .payment-paypay-btn:disabled:hover {
  cursor: not-allowed;
  background: #dfdfdf;
  opacity: 1;
}

.skeleton-loader {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;
}

.skeleton {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 5px;
}

/* スケルトンのボタンサイズ */
.skeleton-button {
  width: 300px;
  height: 50px;
}

/* スケルトンのアニメーション */
@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
}

/*メリット*/
.yagiprime_merit {
  margin-bottom: 50px;
}

.yagiprime_merit .yagiprime_merit-h3 {
  font-size: 18px;
  font-weight: bold;
  color: #004D40;
  margin-bottom: 20px;
}

.yagiprime_merit .yagiprime_merit-list {
  display: flex;
  justify-content: left;
  align-items: center;
  flex-wrap: wrap;
  width: 70%;
}

.yagiprime_merit .yagiprime_merit-item {
  margin-right: 10px;
  margin-bottom: 10px;
}

.yagiprime_merit .yagiprime_merit-image {
  width: 124px;
  min-width: 124px;
  height: 100px;
}

/*注意事項*/
.yagiprime_note {
  margin-bottom: 50px;
}

.yagiprime_note .yagiprime_note-h3 {
  font-size: 18px;
  font-weight: bold;
  color: #004D40;
  margin-bottom: 20px;
}

.yagiprime_note .yagiprime_note-list {
  margin-left: 0;
  margin-bottom: 30px;
  border-radius: 5px;
  padding: 20px 30px;
  background: #fff;
  border: 1px solid #dfdfdf;
  color: #404040;
  height: 200px;
  overflow-y: scroll;
  opacity: 0.8;
}

.yagiprime_note .yagiprime_note-item {
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: end;
  -ms-flex-align: end;
  margin-bottom: 15px;
}

.yagiprime_note .item-left {
  font-weight: bold;
}

.yagiprime_note .item-txt {
  font-size: 12px;
}

.p-ApplePayButton {
  min-height: 50px;
}

@media screen and (max-width: 768px) {
  .yagiprime_merit .yagiprime_merit-list {
    width: 100%;
    flex-wrap: nowrap;
    overflow: scroll;
  }
}

/*画面右固定*/

@media screen and (max-width: 768px) {
  .renew3_payment {
    display: block;
  }

  .renew3_payment .how2,
  .renew3_payment .payment_amount {
    width: 100%;
  }

  /*画面下固定*/
  .renew3_payment .payment_amount {
    position: fixed;
    padding-bottom: 25px;
    left: 0;
    bottom: -10px;
    z-index: 5;
    top: auto;
  }
}
</style>
